import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SWAlertService } from '../../services/swalert.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { TSFuntionService } from '../../services/ts-funtion.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {

  get f() { return this.companyForm.controls; }
  companyForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private swal: SWAlertService,
    private router: Router,
    private System: TSFuntionService
  ) { }

  ResultPermission: boolean = true;
  isResult: boolean = false;
  isResultAdd: boolean = false;

  async ngOnInit() {
    this.companyForm = this.formBuilder.group({
      COMPANY_CODE: ['', Validators.required],
      COMPANY: ['', Validators.required],
      COMPANY_NAME: ['', Validators.required],
      cActive: ['Y', Validators.required],
    });

    this.ResultPermission = await this.System.CheckPermissionMeun(12); //F = ดู, T = แก้ 
    if (this.ResultPermission == false) {
      this.isResult = true;
      this.isResultAdd = true;
    }
    else {
      this.isResult = false;
      this.isResultAdd = false;
    }

    this.GetData();
  }

  //#region Table
  FilterGrid = {
    sSearch: "",
    nStatusID: "",
  }

  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";
  sDetailData = "";

  _ArrData = [];
  ArrSet = [];
  _ArrDataBind = [];
  IsDelete: boolean = false;
  //Filter
  sSearch = "";
  nStatusID = "";
  //---------------------
  //#endregion

  //#region Header Colomn
  @Output() onChange = new EventEmitter();
  Columns = [
    { ColumnName: "Company Code", SortField: "COMPANY_CODE", Width: "15%" },
    { ColumnName: "Short Name", SortField: "COMPANY", Width: "30%" },
    { ColumnName: "Full Name", SortField: "COMPANY_NAME", Width: "35%" },
    { ColumnName: "Status", SortField: "Status", Width: "15%" },
    { ColumnName: "", SortField: "", Width: "5%" }
  ]
  //#endregion

  //#region Event
  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => this.OptionGrid.nCurrentPage = 1);
    this.BindDataTable();
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  GetData() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sSearch', this.FilterGrid.sSearch)
        .set('nStatusID', this.FilterGrid.nStatusID)
    };
    this.http.get<any>(this.System.SiteName + "api/Company/ReadCompany", httpOptions).subscribe(res => {
      if (res) {
        this._ArrData = res;
      }
      else {
        this._ArrData = [];
      }
      this.BindDataTable();
    });
  }

  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    let nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBind = [];
    //this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({ IsDelete: val.cActive == "N" ? true : false }, { IsCOMPANY_CODE: val.COMPANY_CODE == "385" || val.COMPANY_CODE == "388" || val.COMPANY_CODE == "396" || val.COMPANY_CODE == "81" ? true : false }, val)));
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({ IsDelete: false }, { IsCOMPANY_CODE: val.COMPANY_CODE == "385" || val.COMPANY_CODE == "388" || val.COMPANY_CODE == "396" || val.COMPANY_CODE == "81" || val.cActive == "N" ? true : false }, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);

    //this._ArrData.forEach(val => this.ArrSet.push(Object.assign({ IsCOMPANY_CODE: val.COMPANY_CODE == "385" || val.COMPANY_CODE == "388" || val.COMPANY_CODE == "396" || val.COMPANY_CODE == "81" ? true : false}, val)));

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " entries";
  }
  //#endregion

  //#region Sweet Alert OnClick
  onClick(value: string) {
    let _this = this;
    switch (value) {
      case "Submit":
        if (this.companyForm.invalid) {
          this.validateAllFormFields(this.companyForm);
        } else {
          this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Submit, function () { _this.onSubmit() }, undefined)
        }
        break;
      case "Back":
        this.router.navigate(["/admin-menu"]);
        break;
      case "Reset":
        this.onReset()
        break;
      case "Delete":
        this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, "Do you want to Inactive data?", function () { _this.onDelete() }, undefined)
        break;
      default:
    }
  }
  //#endregion

  //#region Validate
  isFieldValid(field: string) {
    return !this.companyForm.get(field).valid && this.companyForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  //#endregion

  //#region Check Company Code
  chkCode(comCode) {
    let formObj = this.companyForm.getRawValue();
    if (formObj.COMPANY_CODE === "") {
      return;
    }

    this.http.get(this.System.SiteName + "api/Company/CheckCompany/" + comCode, { responseType: 'text' }).subscribe(res2 => {
      if (res2 == "True") {
        //window.alert("short name is duplicate.");
        this.companyForm.patchValue({
          COMPANY_CODE: ''
        });
      }
    });
  }
  //#endregion

  //#region Button Save
  onSubmit() {
    //let _this = this;
    this.System.BlockUI();
    if (this.companyForm.invalid) {
      return;
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let formObj = this.companyForm.getRawValue();
    let ITEM = JSON.stringify(formObj);
    this.http.post(this.System.SiteName + 'api/Company/SaveCompany', ITEM, { headers, responseType: 'text' }).subscribe(res => {
      if (res == "Success") {
        this.System.UnBlockUI();
        this.swal.SwAlert.Success(this.swal.BoxMsg.Title_Success, this.swal.BoxMsg.Desc_Success_Save, function () { });
        this.companyForm.reset();
        this.companyForm.controls.COMPANY_CODE.enable();
        this.GetData();
      } else {
        this.System.UnBlockUI();
        this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, res, function () { })
      }
    }
    );
  }
  //#endregion

  //#region Button Edit
  onEdit(COMPANY_CODE, COMPANY, COMPANY_NAME, cActive) {
    this.companyForm.reset();
    this.companyForm.patchValue({
      COMPANY_CODE: COMPANY_CODE,
      COMPANY: COMPANY,
      COMPANY_NAME: COMPANY_NAME,
      cActive: cActive
    });
    this.companyForm.controls.COMPANY_CODE.disable();
    document.getElementById('Top').scrollIntoView({ behavior: "smooth" }); //เลื่อนขึ้นบนสุด
  }
  //#endregion

  //#region Button View
  onView(COMPANY_CODE, COMPANY, COMPANY_NAME, cActive) {
    this.isResultAdd = false;
    this.companyForm.reset();
    this.companyForm.patchValue({
      COMPANY_CODE: COMPANY_CODE,
      COMPANY: COMPANY,
      COMPANY_NAME: COMPANY_NAME,
      cActive: cActive
    });
    this.companyForm.controls.COMPANY_CODE.disable();
    this.companyForm.controls.COMPANY.disable();
    this.companyForm.controls.COMPANY_NAME.disable();
    this.companyForm.controls.cActive.disable();
    document.getElementById('Top').scrollIntoView({ behavior: "smooth" }); //เลื่อนขึ้นบนสุด
  }
  //#endregion

  //#region Button Reset
  onResult() {
    this.companyForm.reset();
    this.isResultAdd = true;
  }
  //#region Button Reset
  onReset() {
    this.companyForm.reset();
    this.companyForm.controls.COMPANY_CODE.enable();
    this.companyForm.controls.cActive.patchValue('Y');
    //this.companyForm.patchValue({
    //  cActive: 'Y'
    //});
  }
  //#endregion

  ClearData() {
    this.FilterGrid.sSearch = "";
    this.FilterGrid.nStatusID = "";
  }

  IsAll: boolean = false;
  ArrDelete: any[] = [];
  CheckAll() {
    if (this.IsAll) {
      this.IsDelete = true;
    } else {
      this.IsDelete = false;
    }
    //this._ArrDataBind.forEach(f => f.IsDelete = this.IsAll && f.IsCOMPANY_CODE == false);
    this._ArrDataBind.forEach(f => f.IsDelete = this.IsAll);
  }

  checkDel() {
    this.IsDelete = this._ArrDataBind.filter(f => f.IsDelete == true).length > 0 ? true : false;
  }


  onDelete() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    this._ArrDataBind.forEach(f =>
      this.ArrDelete.push({
        COMPANY_CODE: f.COMPANY_CODE,
        COMPANY: f.COMPANY,
        COMPANY_NAME: f.COMPANY_NAME,
        Status: f.Status,
        cActive: f.cActive,
        IsDelete: f.IsDelete
      }))
    let ITEM = JSON.stringify(this.ArrDelete);
    this.System.BlockUI();
    this.http.post(this.System.SiteName + 'api/Company/Delete', ITEM, { headers, responseType: 'text' }).subscribe(res => {
      if (res == "Success") {
        this.System.UnBlockUI();
        this.swal.SwAlert.Success(this.swal.BoxMsg.Title_Success, this.swal.BoxMsg.Desc_Success_Save, function () { })
        this.GetData();
        this.IsDelete = false;
      } else {
        this.System.UnBlockUI();
        this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, res, function () { })
      }
    }
    );
  }

}
